import {mat2d, vec2} from "gl-matrix"
import {Vector2} from "../utils/Vector2";
import {transform} from "../utils/glMatrixUtils";


export class Camera {
    position: Vector2 = new Vector2()
    visibleHeight: number = 0.5
    viewMatrix: mat2d = mat2d.create()
    viewMatrixInv: mat2d = mat2d.create()
    backgroundColor?: string

    constructor(options?: Partial<Camera>) {
        Object.assign(this, options)
    }

    cameraToWorld(vector: Vector2) {
        return transform(this.viewMatrixInv, vector)
    }

    update(ctx: CanvasRenderingContext2D) {

        const currentScale = ctx.canvas.height / this.visibleHeight;
        mat2d.identity(this.viewMatrix);
        mat2d.translate(this.viewMatrix, this.viewMatrix, vec2.fromValues(Math.round(ctx.canvas.width * 0.5), Math.round(ctx.canvas.height * 0.5)));
        mat2d.scale(this.viewMatrix, this.viewMatrix, vec2.fromValues(currentScale, -currentScale));
        mat2d.translate(this.viewMatrix, this.viewMatrix, vec2.fromValues(-this.position.x, -this.position.y));
        mat2d.invert(this.viewMatrixInv, this.viewMatrix);

    }

    activate(ctx: CanvasRenderingContext2D) {
        ctx.resetTransform();
        if (this.backgroundColor) {
            ctx.save();
            ctx.fillStyle = this.backgroundColor;
            ctx.beginPath();
            ctx.rect(0, 0, ctx.canvas.width, ctx.canvas.height);
            ctx.fill();
            ctx.restore();
        } else {
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        }
        (ctx.setTransform as any)(...this.viewMatrix);
    }
}